<template>
  <div id="pageChatBotAdmin">
    <v-container fluid>
      <!-- Header con estadísticas
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card h-100">
            <v-card-text class="pa-4">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-4" size="52" class="mr-4">
                  <v-icon color="primary" size="28">mdi-message-text</v-icon>
                </v-avatar>
                <div>
                  <div class="text-h5 font-weight-bold">{{ totalItems }}</div>
                  <div class="text-subtitle-2 grey--text text--darken-1">Total conversaciones</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card h-100">
            <v-card-text class="pa-4">
              <div class="d-flex align-center">
                <v-avatar color="blue lighten-4" size="52" class="mr-4">
                  <v-icon color="blue" size="28">mdi-chart-line</v-icon>
                </v-avatar>
                <div>
                  <div class="text-h5 font-weight-bold">{{ totalTokens }}</div>
                  <div class="text-subtitle-2 grey--text text--darken-1">Tokens totales</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- Tabla de conversaciones -->
      <v-card class="elevation-2">
        <v-toolbar color="primary" dark flat>
          <v-icon class="mr-2">mdi-robot</v-icon>
          <v-toolbar-title>
            Conversaciones del ChatBot
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-col cols="3" class="mr-3">
            <v-text-field
              v-model="filter.search"
              label="Buscar..."
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
              rounded
              single-line
              filled
              dense
              dark
              @input="applyFilter"
            ></v-text-field>
          </v-col>
          
          <!-- Menú de filtros -->
          <filter-menu 
            title="Filtrar conversaciones" 
            :current-filter="currentFilter" 
            @canceled="rollbackFilter()"
            @filtered="commitFilter()"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="filter.dealer_id"
                  :items="dealerItems"
                  item-value="id"
                  item-text="name"
                  label="Dealer"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  prepend-inner-icon="mdi-store"
                ></v-autocomplete>
                
                <v-text-field
                  v-model="filter.user_email"
                  label="Email Usuario"
                  type="email"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
                
                <v-text-field
                  v-model="filter.url_pantalla"
                  label="URL Pantalla"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  prepend-inner-icon="mdi-web"
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="filter.fecha_desde"
                  label="Fecha desde"
                  type="date"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  prepend-inner-icon="mdi-calendar-start"
                ></v-text-field>
                
                <v-text-field
                  v-model="filter.fecha_hasta"
                  label="Fecha hasta"
                  type="date"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  class="mb-4"
                  prepend-inner-icon="mdi-calendar-end"
                ></v-text-field>
              </v-col>
            </v-row>
          </filter-menu>
          
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="exportToExcel" v-on="on" class="mr-2" color="white" :disabled="loadingItems || loadingExport">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>
          
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="loadData" v-on="on" class="mr-2" color="white" :disabled="loadingItems">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Actualizar lista</span>
          </v-tooltip>
        </v-toolbar>
        
        <!-- Filtros activos -->
        <v-card-text class="py-2 px-4" v-if="hasActiveFilters">
          <v-row class="align-center">
            <v-col cols="auto">
              <div class="d-flex align-center flex-wrap">
                <span class="text-caption mr-2 grey--text">Filtros aplicados:</span>
                
                <v-chip v-if="filter.search" x-small class="mr-1 mb-1" close
                  @click:close="filter.search = null; applyFilter()">
                  <v-icon left x-small>mdi-magnify</v-icon>
                  Búsqueda: {{ filter.search }}
                </v-chip>
                
                <v-chip v-if="filter.dealer_id" x-small class="mr-1 mb-1" close
                  @click:close="filter.dealer_id = null; applyFilter()">
                  <v-icon left x-small>mdi-store</v-icon>
                  Dealer: {{ getDealerName(filter.dealer_id) }}
                </v-chip>
                
                <v-chip v-if="filter.user_email" x-small class="mr-1 mb-1" close
                  @click:close="filter.user_email = null; applyFilter()">
                  <v-icon left x-small>mdi-email</v-icon>
                  Email: {{ filter.user_email }}
                </v-chip>
                
                <v-chip v-if="filter.url_pantalla" x-small class="mr-1 mb-1" close
                  @click:close="filter.url_pantalla = null; applyFilter()">
                  <v-icon left x-small>mdi-web</v-icon>
                  URL: {{ filter.url_pantalla }}
                </v-chip>
                
                <v-chip v-if="filter.fecha_desde" x-small class="mr-1 mb-1" close
                  @click:close="filter.fecha_desde = null; applyFilter()">
                  <v-icon left x-small>mdi-calendar-start</v-icon>
                  Desde: {{ filter.fecha_desde }}
                </v-chip>
                
                <v-chip v-if="filter.fecha_hasta" x-small class="mr-1 mb-1" close
                  @click:close="filter.fecha_hasta = null; applyFilter()">
                  <v-icon left x-small>mdi-calendar-end</v-icon>
                  Hasta: {{ filter.fecha_hasta }}
                </v-chip>
              </div>
            </v-col>
            
            <v-col cols="auto">
              <v-btn x-small text color="primary" @click="resetFilters">
                <v-icon left small>mdi-filter-remove</v-icon>
                Limpiar filtros
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-divider v-if="hasActiveFilters"></v-divider>
        
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loadingItems"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
              'items-per-page-text': 'Filas por página:'
            }"
            class="elevation-0"
            :mobile-breakpoint="0"
          >
          <template v-slot:item.created_at_formatted="{ item }">
            <div class="d-flex align-center">
              <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
              {{ item.created_at_formatted }}
            </div>
          </template>

          <template v-slot:item.dealer_name="{ item }">
            <v-chip small color="primary" outlined v-if="item.dealer_name">
              <v-icon small left>mdi-store</v-icon>
              {{ item.dealer_name }}
            </v-chip>
            <span v-else class="grey--text">—</span>
          </template>

          <template v-slot:item.user_name="{ item }">
            <div>
              <div class="font-weight-medium">{{ item.user_name }}</div>
              <div class="caption grey--text">{{ item.user_email }}</div>
            </div>
          </template>

          <template v-slot:item.mensaje_usuario="{ item }">
            <div class="text-truncate" style="max-width: 300px;" :title="item.mensaje_usuario">
              {{ item.mensaje_usuario }}
            </div>
          </template>

          <template v-slot:item.respuesta_bot="{ item }">
            <div class="text-truncate" style="max-width: 300px;" :title="item.respuesta_bot">
              {{ item.respuesta_bot }}
            </div>
          </template>

          <template v-slot:item.tokens_usados="{ item }">
            <v-chip small :color="getTokenColor(item.tokens_usados)">
              {{ item.tokens_usados }}
            </v-chip>
          </template>

          <template v-slot:item.url_pantalla="{ item }">
            <v-chip small color="grey" outlined v-if="item.url_pantalla">
              <v-icon small left>mdi-web</v-icon>
              {{ item.url_pantalla }}
            </v-chip>
            <span v-else class="grey--text">—</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon small @click="viewDetails(item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Dialog de detalles -->
    <v-dialog v-model="detailDialog" max-width="800px">
      <v-card v-if="selectedItem">
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-message-text-outline</v-icon>
          Detalles de la conversación
          <v-spacer></v-spacer>
          <v-btn icon dark @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" md="6">
              <div class="mb-2">
                <span class="font-weight-bold">ID:</span> {{ selectedItem.id }}
              </div>
              <div class="mb-2">
                <span class="font-weight-bold">Session ID:</span> {{ selectedItem.session_id }}
              </div>
              <div class="mb-2">
                <span class="font-weight-bold">Fecha:</span> {{ selectedItem.created_at_formatted }}
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="mb-2">
                <span class="font-weight-bold">Dealer:</span> {{ selectedItem.dealer_name || '—' }}
              </div>
              <div class="mb-2">
                <span class="font-weight-bold">Usuario:</span> {{ selectedItem.user_name }}
              </div>
              <div class="mb-2">
                <span class="font-weight-bold">Email:</span> {{ selectedItem.user_email }}
              </div>
            </v-col>
            <v-col cols="12">
              <div class="mb-2">
                <span class="font-weight-bold">URL Pantalla:</span> {{ selectedItem.url_pantalla || '—' }}
              </div>
              <div class="mb-2">
                <span class="font-weight-bold">Tokens usados:</span> 
                <v-chip small :color="getTokenColor(selectedItem.tokens_usados)" class="ml-2">
                  {{ selectedItem.tokens_usados }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
          
          <v-divider class="my-4"></v-divider>
          
          <div class="mb-3">
            <div class="font-weight-bold mb-2">Mensaje del usuario:</div>
            <v-card outlined class="pa-3 blue lighten-5">
              {{ selectedItem.mensaje_usuario }}
            </v-card>
          </div>
          
          <div>
            <div class="font-weight-bold mb-2">Respuesta del bot:</div>
            <v-card outlined class="pa-3 grey lighten-4">
              {{ selectedItem.respuesta_bot }}
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChatBotService from '@/services/ChatBotService'
import DealerService from '@/services/DealerService'
import FilterMenu from '@/components/FilterMenu'

export default {
  name: 'ChatBotAdmin',
  components: {
    FilterMenu
  },
  data () {
    return {
      loading: false,
      loadingItems: false,
      loadingExport: false,
      items: [],
      totalItems: 0,
      totalTokens: 0,
      options: {
        page: 1,
        itemsPerPage: 20
      },
      headers: [
        { text: 'Fecha', value: 'created_at_formatted', sortable: false },
        { text: 'Dealer', value: 'dealer_name', sortable: false },
        { text: 'Usuario', value: 'user_name', sortable: false },
        { text: 'Mensaje', value: 'mensaje_usuario', sortable: false },
        { text: 'Respuesta', value: 'respuesta_bot', sortable: false },
        { text: 'Tokens', value: 'tokens_usados', sortable: false },
        { text: 'URL', value: 'url_pantalla', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      filter: {
        search: null,
        dealer_id: null,
        user_email: null,
        url_pantalla: null,
        fecha_desde: null,
        fecha_hasta: null
      },
      currentFilter: {},
      dealerItems: [],
      detailDialog: false,
      selectedItem: null
    }
  },
  computed: {
    hasActiveFilters () {
      return this.filter.search ||
             this.filter.dealer_id || 
             this.filter.user_email ||
             this.filter.url_pantalla ||
             this.filter.fecha_desde || 
             this.filter.fecha_hasta
    }
  },
  watch: {
    options: {
      handler () {
        this.loadData()
      },
      deep: true
    }
  },
  created () {
    this.loadDealers()
  },
  methods: {
    async loadData () {
      this.loadingItems = true
      try {
        const params = {
          page: this.options.page,
          'per-page': this.options.itemsPerPage
        }
        
        // Agregar filtros si existen
        if (this.filter.search) params.search = this.filter.search
        if (this.filter.dealer_id) params.dealer_id = this.filter.dealer_id
        if (this.filter.user_email) params.user_email = this.filter.user_email
        if (this.filter.url_pantalla) params.url_pantalla = this.filter.url_pantalla
        if (this.filter.fecha_desde) params.fecha_desde = this.filter.fecha_desde
        if (this.filter.fecha_hasta) params.fecha_hasta = this.filter.fecha_hasta
        
        const response = await ChatBotService.listConversations(params)
        
        // La estructura es: response.data.data.data (array de conversaciones)
        this.items = response.data?.data?.data || []
        this.totalItems = response.data?.data?.pagination?.total || 0
        
        // Calcular total de tokens
        this.totalTokens = this.items.reduce((sum, item) => sum + (item.tokens_usados || 0), 0)
      } catch (e) {
        if (this.$toast) this.$toast.error('Error al cargar las conversaciones')
        console.error('Error loading conversations:', e)
        console.error('Error response:', e.response)
      } finally {
        this.loadingItems = false
      }
    },
    
    async loadDealers () {
      try {
        const { data } = await DealerService.get()
        this.dealerItems = data?.data || []
      } catch (e) {
        console.error('Error loading dealers:', e)
      }
    },
    
    rollbackFilter () {
      this.filter = { ...this.currentFilter }
    },
    
    commitFilter () {
      this.currentFilter = { ...this.filter }
      this.applyFilter()
    },
    
    applyFilter () {
      this.loadData()
    },
    
    async exportToExcel () {
      this.loadingExport = true
      try {
        const params = {}
        
        // Agregar los mismos filtros que en loadData
        if (this.filter.search) params.search = this.filter.search
        if (this.filter.dealer_id) params.dealer_id = this.filter.dealer_id
        if (this.filter.user_email) params.user_email = this.filter.user_email
        if (this.filter.url_pantalla) params.url_pantalla = this.filter.url_pantalla
        if (this.filter.fecha_desde) params.fecha_desde = this.filter.fecha_desde
        if (this.filter.fecha_hasta) params.fecha_hasta = this.filter.fecha_hasta
        
        const response = await ChatBotService.exportToExcel(params)
        console.log('Respuesta del servidor:', response)
        
        // El response.data ya es un Blob con el tipo correcto
        const blob = response.data
        
        // Verificar que el blob es válido
        if (!blob || blob.size === 0) {
          throw new Error('El archivo descargado está vacío')
        }
        
        console.log('Blob recibido:', {
          size: blob.size,
          type: blob.type
        })
        
        // Crear URL temporal para el blob
        const url = window.URL.createObjectURL(blob)
        
        // Crear elemento de enlace temporal con fecha y hora
        const link = document.createElement('a')
        link.href = url
        const fecha = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
        link.download = `Conversaciones_ChatBot_${fecha}.xlsx`
        link.style.display = 'none'
        
        // Agregar al DOM, hacer click y limpiar inmediatamente
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // Limpiar URL
        window.URL.revokeObjectURL(url)
        
        if (this.$toast) this.$toast.success('Conversaciones exportadas correctamente')
        console.log('Descarga completada exitosamente')
      } catch (e) {
        if (this.$toast) this.$toast.error('Error al exportar a Excel: ' + (e.message || 'Error desconocido'))
        console.error('Error exporting to Excel:', e)
      } finally {
        this.loadingExport = false
      }
    },
    
    resetFilters () {
      this.filter = {
        search: null,
        dealer_id: null,
        user_email: null,
        url_pantalla: null,
        fecha_desde: null,
        fecha_hasta: null
      }
      this.currentFilter = { ...this.filter }
      this.loadData()
    },
    
    getDealerName (dealerId) {
      const dealer = this.dealerItems.find(d => d.id === dealerId)
      return dealer ? dealer.name : dealerId
    },
    
    getTokenColor (tokens) {
      if (tokens < 100) return 'green'
      if (tokens < 300) return 'orange'
      return 'red'
    },
    
    viewDetails (item) {
      this.selectedItem = item
      this.detailDialog = true
    }
  }
}
</script>

<style scoped>
.stat-card {
  transition: all 0.3s;
  border-left: 4px solid transparent;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-left-color: var(--v-primary-base);
}
</style>
